var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Converts array-like objects to an array.
 *
 * @example
 * toArray({ 0: 'foo', 1: 'bar', length: 2 }) // => ['foo', 'bar']
 */
export var toArray = function (x) { return (x ? [].slice.call(x) : []); };
/**
 * Converts something to an array—if it isn't already.
 *
 * @example
 * castArray([1, 2, 3]) // => [1, 2, 3]
 * castArray(1)         // => [1]
 */
export var castArray = function (x) {
    return Array.isArray(x) ? __spread(x) : [x];
};
/**
 * Gets the last element in an array.
 *
 * @example
 * last([1, 2, 3]) // => 3
 * last([])        // => undefined
 */
export var last = function (xs) { return xs[xs.length - 1]; };
/**
 * Chunks an array into `size` sized portions.
 * Negative values of `size` will yield the same results as `size === 0`.
 *
 * @example
 * chunk(2, [1, 2, 3, 4, 5, 6, 7])
 * // => [[1, 2], [3, 4], [5, 6], [7]]
 */
export function chunk(xs, size) {
    var n = +size;
    if (!xs.length || !n || n < 0 || n > Number.MAX_SAFE_INTEGER) {
        return [__spread(xs)];
    }
    return xs.reduce(function (zs, x, i) {
        if (i % n === 0)
            zs.push([]);
        zs[zs.length - 1].push(x);
        return zs;
    }, []);
}
/**
 * Flattens an array up to max depth `n`.
 * In `n` isn't provided, `1` is assumed.
 *
 * @example
 * flatten([1, 2, 3])               // => [1, 2, 3]
 * flatten([1, [2, 3]])             // => [1, 2, 3]
 * flatten([1, [2, [3]]], Infinity) // => [1, 2, 3]
 */
export function flatten(xs, n) {
    if (n === void 0) { n = 1; }
    if (n <= 0)
        return __spread(xs);
    var results = [];
    for (var i = 0; i < xs.length; i += 1) {
        var x = xs[i];
        results.push.apply(results, __spread((Array.isArray(x) ? flatten(x, n - 1) : [x])));
    }
    return results;
}
/**
 * Removes all falsy values from an array, including:
 * false, null, undefined, NaN, 0, ''.
 *
 * @example
 * compact([1, 0, false, true, '', 'foo']) // => [1, true, 'foo']
 */
export function compact(xs) {
    return xs.filter(Boolean);
}
//# sourceMappingURL=array.js.map